export const DOTS_WIDTH_CONSTANT = 4;
export enum BUTTON {
  PREV,
  NEXT,
}

export const CAROUSEL_ANIMATION_CLASSNAME = 'image-fade-in';
